import { SxProps } from '@mui/material';

export const emarketingSpotMenuSX: SxProps = {
	zIndex: 1500,
};
